import Layout from '../layout';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage ,setActiveLanguage, addTranslationForLanguage, setLanguages} from 'react-localize-redux';
import { toJS } from './to-js';
import { loadChat, logout } from '../actions/user';
import { getCompanyDetails,getCustomIcons, getLanguageTranslations } from '../actions/company';
import { fetchNavWorkflows, fetchNavWorkflowsPublic, getOfflineWorkflows } from '../actions/workflows';
import { getAllReports } from '../actions/reports';

const mapStateToProps = (state) => {
    const locale = state.get('locale');
    const companySettings = state.getIn(['company', 'details', 'data', 'companySettings']);
    const allReports =  state.getIn(['reports', 'allReports'])
    return { 
        translate: getTranslate(locale),
       currentLanguage: getActiveLanguage(locale) ? getActiveLanguage(locale).code : 'en',
        user: state.get('user'),
        isDashboard: false,
        companyDetails: state.getIn(['company', 'details']),
        availableLanguages : companySettings && companySettings.get('langauges'),
        allReports,
      };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: (history,companyDetails) => {
            dispatch(logout(history,companyDetails));
        },
        getCompanyDetails: () => {
            dispatch(getCompanyDetails());
        },
        getCustomIcons: () => {
            dispatch(getCustomIcons());
        },
        fetchNavWorkflows: (user) => {
            if(user) {
                dispatch(fetchNavWorkflows(user));
            }
        },
          setActiveLanguage : payload => {
                    dispatch(setActiveLanguage(payload))
                },
        fetchNavWorkflowsPublic: (user) => {
            if(user) {
                dispatch(fetchNavWorkflowsPublic(user));
            }
        },
        getLanguageTranslations : () => {
            return dispatch(getLanguageTranslations())
        },
        addTranslationForLanguage : (lang, code) => {
            dispatch(addTranslationForLanguage(lang, code));
        },
        setLanguages : (langs) => {
            dispatch(setLanguages(langs));
        },
        getOfflineWorkflows: () => {
            dispatch(getOfflineWorkflows());
        },
          getAllReports: () => {
            dispatch(getAllReports());
        },
        loadChat: (messages) => {
      dispatch(loadChat(messages));
    },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(Layout));